import { usePaginatedFields } from '@cibo/landmanager'
import { useAuth } from '@cibo/profile'
import { usePrograms } from '@cibo/programs'
import { useNeedsInfoFieldsCount } from '../../ProfileFields'

export const useFieldStatusCounts = () => {
  const { userId } = useAuth()
  const programs = usePrograms()

  const allFields = usePaginatedFields(
    0,
    1,
    { footprintResolved: true },
    { refetchOnMount: 'always' }
  )

  const sensing = usePaginatedFields(
    0,
    1,
    { footprintResolved: false },
    { refetchOnMount: 'always' }
  )

  const disqualifiedFields = usePaginatedFields(
    0,
    1,
    {
      owner: userId,
      allPrograms: programs.data?.map(({ programId }) => ({
        id: programId,
        benchmarks: [{ benchmark: 'profile', status: 'fail' }],
      })),
    },
    { refetchOnMount: 'always' }
  )

  const eligible = usePaginatedFields(
    0,
    1,
    {
      owner: userId,
      anyPrograms: programs.data?.map(({ programId }) => ({
        id: programId,
        benchmarks: [{ benchmark: 'profile', status: 'pass' }],
        participating: false,
      })),
    },
    { refetchOnMount: 'always' }
  )

  const needsInfoFields = useNeedsInfoFieldsCount({ owner: userId }, { refetchOnMount: 'always' })

  const queries = { allFields, eligible, sensing, disqualifiedFields, needsInfoFields }
  const queriesList = Object.values(queries)

  return {
    ...queries,

    isLoading: queriesList.find(query => query.isLoading)?.isLoading,
    isError: queriesList.find(query => query.isError)?.isError,
    error: queriesList.find(query => query.error)?.error,
  }
}
